import React, { useState } from 'react';
import {
  IconButton,
  Tooltip,
} from '@mui/material';
import { useLanguage } from '../../../../context/LanguageContext';
import { useUserData } from '../../../../context/UserDataContext';
import { LoyaltyCardDialog } from '../../../Common';

const LoyaltyCardButton: React.FC = () => {
  const { t } = useLanguage();
  const { personData, loading } = useUserData();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Tooltip title={t('header.loyaltyCard') || 'Ma carte de fidélité'}>
        <IconButton onClick={handleOpen} sx={{ color: '#495057' }}>
          <i className="bx bx-credit-card" style={{ fontSize: 22 }} />
        </IconButton>
      </Tooltip>

      <LoyaltyCardDialog 
        open={open} 
        onClose={handleClose}
        personData={personData}
        loading={loading}
      />
    </>
  );
};

export default LoyaltyCardButton;

